import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api/client';
import {
  ApiRoutes,
  type AdminMembership,
  type AdminMembershipList,
  type InviteAdminRequest,
} from '@condo/contracts';
import { queryKeys } from '@/lib/api/query-keys';

export function useAdmins(tenantId: string) {
  return useQuery({
    queryKey: queryKeys.admins(tenantId),
    queryFn: () => api.get<AdminMembershipList>(ApiRoutes.condominioAdmins(tenantId)),
    enabled: !!tenantId,
  });
}

export function useInviteAdmin(tenantId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: InviteAdminRequest) =>
      api.post<AdminMembership, InviteAdminRequest>(ApiRoutes.condominioAdmins(tenantId), body),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.admins(tenantId) }),
  });
}

export function useRevokeAdmin(tenantId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) =>
      api.delete(ApiRoutes.condominioAdmin(tenantId, userId)),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.admins(tenantId) }),
  });
}
